export interface ISituacaoMinuta {
	codigo: number;
	descricao: string;
	ativo: boolean;
	ordem?: number;
}

export enum SituacaoMinuta {
	INEXISTENTE = 10,
	EM_ELABORACAO = 20,
	EM_REVISAO = 25,
	LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA = 30,
	ASSINATURA_VERIFICADA = 31,
	MINUTA_SALVA_NA_ORIGEM = 32,
	PROCESSO_MOVIMENTADO_NO_FLUXO = 33,
	LANÇADOS_OS_MOVIMENTOS_NO_PROCESSO = 34,
	PETICOES_APRECIADAS = 35,
	ASSINADA = 40,
	ARQUIVADA = 65,
	BLOQUEADA_PELA_SECRETARIA = 50,
	PUBLICADA = 60,
	DEVOLVIDA_PARA_CORRECAO = 70
}

export class MINUTA_INEXISTENTE implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.INEXISTENTE;
	descricao: string = "INEXISTENTE";
	ativo: boolean = true;

}
export class MINUTA_EM_ELABORACAO implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.EM_ELABORACAO;
	descricao: string = "EM ELABORAÇÃO";
	ativo: boolean = true;

}

export class MINUTA_EM_REVISAO implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.EM_REVISAO;
	descricao: string = "EM REVISAO";
	ativo: boolean = true;

}

export class MINUTA_LIBERADA implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA;
	descricao: string = "LIBERADA PARA ASSINATURA OU LIBERADA PARA INCLUSÃO EM PAUTA";
	ativo: boolean = true;

}

export class MINUTA_COM_VISTO_ASSINADO implements ISituacaoMinuta { // minutas com situacao 30 e minuta.vistoLiberado = true
	codigo: number = SituacaoMinuta.LIBERADA_PARA_ASSINATURA_OU_INCLUSAO_EM_PAUTA;
	descricao: string = "VISTO ASSINADO";
	ativo: boolean = true;

}

export class MINUTA_ASSINATURA_VERIFICADA implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.ASSINATURA_VERIFICADA;
	descricao: string = "ASSINATURA VERIFICADA";
	ativo: boolean = true;

}

export class MINUTA_SALVA_NA_ORIGEM implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.MINUTA_SALVA_NA_ORIGEM;
	descricao: string = "MINUTA SALVA NA ORIGEM";
	ativo: boolean = true;

}
export class MINUTA_PROCESSO_MOVIMENTADO_NO_FLUXO implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.PROCESSO_MOVIMENTADO_NO_FLUXO;
	descricao: string = "PROCESSO MOVIMENTADO NO FLUXO";
	ativo: boolean = true;

}
export class MINUTA_LANÇADOS_OS_MOVIMENTOS_NO_PROCESSO implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.LANÇADOS_OS_MOVIMENTOS_NO_PROCESSO;
	descricao: string = "LANÇADOS OS MOVIMENTOS NO PROCESSO";
	ativo: boolean = true;

}
export class MINUTA_PETICOES_APRECIADAS implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.PETICOES_APRECIADAS;
	descricao: string = "PETICOES APRECIADAS";
	ativo: boolean = true;

}
export class MINUTA_ASSINADA implements ISituacaoMinuta { // minutas com situacao 30 e minuta.vistoLiberado = true
	codigo: number = SituacaoMinuta.ASSINADA;
	descricao: string = "ASSINADA";
	ativo: boolean = true;
}
export class MINUTA_ARQUIVADA implements ISituacaoMinuta { // minutas com situacao 30 e minuta.vistoLiberado = true
	codigo: number = SituacaoMinuta.ARQUIVADA;
	descricao: string = "ARQUIVADA";
	ativo: boolean = true;
}
export class MINUTA_BLOQUEADA_PELA_SECRETARIA implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.BLOQUEADA_PELA_SECRETARIA;
	descricao: string = "BLOQUEADA PELA SECRETARIA";
	ativo: boolean = true;

}
export class MINUTA_PUBLICADA implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.PUBLICADA;
	descricao: string = "PUBLICADA";
	ativo: boolean = true;

}


export class MINUTA_DEVOLVIDA implements ISituacaoMinuta {
	codigo: number = SituacaoMinuta.DEVOLVIDA_PARA_CORRECAO;
	descricao: string = "DEVOLVIDA PARA CORREÇÃO";
	ativo: boolean = true;

}



export const SITUACOES_DE_MINUTA = [new MINUTA_EM_ELABORACAO(), new MINUTA_LIBERADA(), new MINUTA_DEVOLVIDA(), new MINUTA_COM_VISTO_ASSINADO()];